import BigNumber from 'bignumber.js'

import { DelugeId } from '@root/entities/user-short'

import type { LeaderboardApi } from '@root/shared/api'

export type TradeLeaderboardEntry = {
  id: DelugeId
  username: string | undefined
  position: number
  registrationDate: Date
  profitUsd: BigNumber
}

export const tradeEntryFromDto = (
  dto: LeaderboardApi.LeaderboardTradeItemDto,
): TradeLeaderboardEntry => {
  return {
    username: dto.username,
    id: DelugeId(dto.delugeId),
    profitUsd: BigNumber(dto.tradeInfo.usdProfit),
    registrationDate: new Date(dto.createdAt),
    position: dto.position,
  }
}

export type ReferralLeaderboardEntry = {
  id: DelugeId
  username: string | undefined
  referralCount: number
  totalReferralBalanceUsd: BigNumber
  totalReferralScore: number
  position: number
  registrationDate: Date
}

export const referralEntryFromDto = (
  dto: LeaderboardApi.LeaderboardReferralItemDto,
): ReferralLeaderboardEntry => {
  return {
    id: DelugeId(dto.delugeId),
    username: dto.username,
    position: dto.position,
    referralCount: dto.totalReferrals,
    totalReferralBalanceUsd: BigNumber(dto.totalReferralBalanceUsd),
    totalReferralScore: dto.totalReferralScore,
    registrationDate: new Date(dto.createdAt),
  }
}
